/**
 * @internal
 */
export const getCellIcon = (column, rowIndex) => typeof column.cellIcon === 'function' ? column.cellIcon(rowIndex) : column.cellIcon;

/**
 * @internal
 */
export const getCellHelpPopup = (column, rowIndex) => typeof column.cellHelpPopup === 'function' ? column.cellHelpPopup(rowIndex) : column.cellHelpPopup;

/**
 * @internal
 */
export const getCellMenuButton = (column, rowIndex) => typeof column.cellMenuButton === 'function' ? column.cellMenuButton(rowIndex) : column.cellMenuButton;
//# sourceMappingURL=utils.js.map